import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { gbp, fmtDate } from "./bookingFormat";
import { FollowUpControl } from "./FollowUpControl";
import { SeenToggle } from "./SeenToggle";

const Line = ({ label, children }) => (
  <div className="flex gap-3 text-sm"><span className="w-28 shrink-0 text-ink-muted">{label}</span><span className="text-ink">{children || "—"}</span></div>
);

export const BookingDetailDialog = ({ booking: b, onClose }) => (
  <Dialog open={!!b} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid="cal-booking-dialog" className="max-w-lg">
      {b && (<>
        <DialogHeader><DialogTitle className="font-serif text-2xl">{b.patient_name || "Booking"}</DialogTitle></DialogHeader>
        <div className="space-y-2 mt-2">
          <Line label="When">{fmtDate(b.start_time)}</Line>
          <Line label="Consultant">{b.consultant}</Line>
          <Line label="Type">{b.visit_type}</Line>
          <Line label="Status">{b.state === "pending" ? "Awaiting payment" : "Paid"}</Line>
          <Line label="Email">{b.patient_email}</Line>
          <Line label="Phone">{b.patient_phone}</Line>
          <Line label="Coming about">{(b.reasons || []).join(" · ")}</Line>
          <Line label="Paid">{b.amount ? gbp(b.amount) : ""}</Line>
          {b.state === "paid" && <Line label="Seen at clinic"><SeenToggle email={b.patient_email} testId="cal-seen-toggle" invited={b.followup_invite === "sent"} /></Line>}
          {b.state === "paid" && <Line label="Follow-up invite"><FollowUpControl row={b} /></Line>}
        </div>
      </>)}
    </DialogContent>
  </Dialog>
);
